let PubSub = function () {
  let events = {};

  let subscribe = function (eventName, callback) {
    if (!events[eventName]) {
      events[eventName] = [];
    }

    events[eventName].push(callback);
  };

  let once = function (eventName, args) {
    if (events[eventName]) {
      return;
    }

    subscribe(eventName, args);
  };

  let unsubscribe = function (eventName, callbackToUnsubscribe) {
    for (var i = 0; i < events[eventName].length; i++) {
      if (events[eventName][i] === callbackToUnsubscribe) {
        events[eventName].splice(i, 1);
        break;
      }
    }
  };

  let publish = function (eventName, args) {
    return events[eventName] &&
      events[eventName].forEach(callback => callback(args));
  };

  return {
    subscribe,
    once,
    unsubscribe,
    publish
  };

}();

export default PubSub;


// WEBPACK FOOTER //
// ./src/js/utils/pub-sub.js